<template>
    <div class="col-lg-12 d-flex flex-column">
      <div class="col-12 pb-5 mb-4" v-if="pageloader">
        <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
      </div>
      <div v-else>
      <div class="row no-gutters pb-5" v-if="serviceVideosList.length === 0">
                <div class="col-12 card mb-4 introvideocard">
                    <div class="row no-gutters p-2" >
                        <div class="col p-5 text-center">
                        <img src="../../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video mx-auto pb-4" alt="novideo">
                        <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Video's Found</div>
                        </div>
                    </div>
                </div>
            </div>
        <div v-if="serviceVideosList.length>0" class="pb-5">
          <div v-for="(service,index) in serviceVideosList" :key="index">
            <div class="card mb-2  mt-lg-2 borderradius10" :id="'companyServiceVideoCardItem'+index">
              <div class="card-body homevideoslist" >
                <div class="d-flex flex-column">                      
                  <div class="videocardhead d-flex justify-content-between p-3">
                    <div class="d-flex" >                      
                      <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize">
                        <span class="fontsize14 black proximanova-semibold nameBlock" >Service Video</span>                        
                      </div>
                    </div>
                  </div>
                  <div class="videocardbody">
                    <div class="col-12   productvideocard">                         
                      <div >                         
                        <video height="300" oncontextmenu="return false" controlsList="nodownload"  :id="'serviceVideo'+index" >
                          <source :src="service.videoLink" id="introvideosrctag">
                        </video>
                      </div>  
                      <div class="card-img-overlay "> 
                        <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1">
                          <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                        </div>
                        <div class="mt-3 mx-auto">
                          <img src="../../assets/play_video.svg" v-if="!service.playingServiceVideo" class="playpausevideobtn" alt="playvideo" @click="playPauseServiceVideo(index, service)">
                          <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="service.playingServiceVideo && service.replayVideo">
                            <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayfollowerVideo(index, service)">
                          </div>
                          <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="service.playingServiceVideo && service.loadingVideo">
                            <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                          </div>
                          <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="service.playingServiceVideo && !service.replayVideo && !service.loadingVideo" alt="pausevideo" @click="playPauseServiceVideo(index, service)">
                        </div>
                        <div class="bottom">
                          <div class="companyvid_overlay2">
                            <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="postvideocontent p-1 pb-2 pl-3 d-flex justify-content-between">                        
                    <div class="d-flex flex-column p-2 descript-section" >
                      <span class="proximanova-semibold fontsize16 black80 text-capitalize">Service video title</span>
                      <span class="proximanova black60 fontsize14 flex-wrap" v-if="service.description">{{service.description}}</span>
                    </div>
                  </div>
                  <!-- <div class="p-3 ml-2">
                    <a  class="btn backgroundcolorblack white mouseoverwhite mouseoverbtn2"  id="search" @click="Contact()">
                        <span class="proximanova-semibold fontsize16">Contact Us</span>
                    </a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>          
        </div>         
        <contactus @onCloseContact = "closeContactModal" v-if="showContactUs"></contactus>   
        </div>
    </div>    
</template>
<script>
import $ from 'jquery'
import postvideomodal from '../../components/postVideoModal.vue'
import httpuserprofile from "@/js/http-userprofile.js";
import contactus from "./ContactUs.vue"
export default{
    data(){
        return{
            pageloader : true,
            addintrovideoimage : require('../../assets/Create_Video.svg'),
            businessAccountId: null,
            companyprofileId: null, 
            serviceVideosList: [],
            playingServiceVideo: false,
            moreVideos : false,
            showContactUs: false
        }
    },
    components: {
      postvideomodal,
      contactus   
    },
    methods:{      
      closeContactModal(){
        this.showContactUs = false
      },
      //play and pause for service
      playPauseServiceVideo : function(index, service) {
        var ind = 'serviceVideo'+index
        var serviceVideo = document.getElementById(ind)
        for(var i = 0; i < this.serviceVideosList.length; i++){
          if(i === index){
            if(!service.playingServiceVideo){
                service.playingServiceVideo = true;
                serviceVideo.play()
            }else{
                service.playingServiceVideo = false;
                serviceVideo.pause()
            }
          }else{
            if(!this.serviceVideosList[i].replayVideo){
            this.serviceVideosList[i].playingServiceVideo = false;
            
            let prevVideo = document.getElementById('serviceVideo'+i)
            prevVideo.pause()
            }
          }
        }
        serviceVideo.onended = function() {
          service.playingServiceVideo = true;
          service.replayVideo = true;
          service.loadingVideo = false;
          var nextIndex = index + 1;
          var nextVideo = document.getElementById("companyServiceVideoCardItem"+nextIndex);
          if(nextVideo){
            nextVideo.scrollIntoView()
          }
        }
        serviceVideo.oncanplay = function() {
          if(service.playingServiceVideo){
            service.loadingVideo = false;
          }
        }
        serviceVideo.onwaiting = function() {
          if(service.playingServiceVideo){
            service.loadingVideo = true;
          }
        }
      },
      replayfollowerVideo(index, service) {
        // console.log("replay video")
        this.serviceVideosList[index].replayVideo = false;
        this.serviceVideosList[index].playingServiceVideo = false;
        this.playPauseServiceVideo(index, service)
      },
      Contact(){
          this.showContactUs = true;
      },      
      // Get the list of service Videos
      getServiceVideos() {
        httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=SERVICE')
        .then((response) => {
          console.log(response)
          this.pageloader = false;
          response.data.forEach((video,index) => {
            video.playingServiceVideo = false;
            video.replayVideo = false;
            video.loadingVideo = false; 
            video.showUpdatebtn = false
          });
          this.serviceVideosList = response.data;
        }).catch((e) => {
          console.log(e)
          this.pageloader = false;
        })
      },
    },
    mounted(){
        $('[data-toggle="tooltip"]').tooltip();
      this.businessAccountId = this.$session.get('business_account_id')
      this.companyprofileId = this.$session.get('company_profile_id')
      this.getServiceVideos();
    }
}
</script>
<style scoped>
.productvideocard{
	padding-left: 0;
	padding-right: 0;
	border-radius: 10px;
  }
.pausebtn{
  display: none;
}
.productvideocard:hover .pausebtn{
  display: block;
  margin-top: 7%;
}
/* video card styles */
.introvideocard{
  padding-left: 0;
  padding-right: 0;
  border-radius: 10px;
}
.pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
.bottom{
	position: absolute;
	width: 100%;
	bottom: 0;
	left: 0;
  }
#introVideo{
  width: 100%;
}
.videoheadsection {
  padding-left: 8px !important;
  padding-right: 0px !important;
}
.homevideoslist{
	padding: 0 !important;
  }
/* video card styles */
.introvideocard{
  padding-left: 0;
  padding-right: 0;
  border-radius: 10px;
}
.card-img-overlay{
  padding: 0;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    background-attachment: scroll;
    overflow: hidden;
    z-index: 0;
}
.videocardbody video {
  background-color: #1F1F1F;
    min-width: 100%;
    width: 100%;
    min-height: 100%;
    position: relative;
    /* z-index: 1; */
    /* object-fit: fill; */
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    /* background: rgba(31, 31, 31, .6); */
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    margin-top: -5px;
}
#introVideo{
  width: 100%;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 35px !important;
  width: 150px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-70%, 10px, 10px) !important;
}
.more_option {
  cursor: pointer;
}
.closebtnmouseover{
  padding-left: 6px;
  padding-right: 2px;
  margin-top: -4px;
  border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;

}
#playvideobtn {
    display: block;
    margin-left: 46%;
    margin-top: 7% !important;
    margin-bottom: 5%;
    cursor: pointer;
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.playpausevideobtn{
  cursor: pointer;
	margin-left: 46%;
	margin-top: 5%;
  z-index: 5 !important;
}
/* details card styles */
.aboutUsDetailsCard{
  border-radius: 10px;
}
a:hover{
  /* color: #007AFF !important; */
}
</style>
